const has = (prop, obj) => Object.prototype.hasOwnProperty.call(obj, prop)

export default has
